<template>
  <div>
    <b-container class="mt-4 mb-4">
      <div class="col-md-8 mt-4 d-flex align-items-start justify-content-between">
        <back-arrow :title="$t('Menu.my.annonces')"/>
      </div>

      <transition-group v-if="isLoading" appear name="listCustomTransition" tag="div">
        <div key="homePlaceHolder-draft" class="mt-4">
          <div class="mb-1">
            <div class="d-flex justify-content-between">
              <h1 class="page-subtitle">{{ $t('annonce.my.draft') }}</h1>
            </div>
          </div>
          <div class="other-annonces card-container row row-cards-annonces">
            <PlaceholderCardAnnonce :isAnimated=true :isForHome=true :isGradient=false></PlaceholderCardAnnonce>
            <PlaceholderCardAnnonce :isAnimated=true :isForHome=true :isGradient=false></PlaceholderCardAnnonce>
            <PlaceholderCardAnnonce :isAnimated=true :isForHome=true :isGradient=false></PlaceholderCardAnnonce>
            <PlaceholderCardAnnonce :isAnimated=true :isForHome=true :isGradient=false></PlaceholderCardAnnonce>
          </div>
        </div>
        <div key="homePlaceHolder-toValidate" class="mt-4">
          <div class="mb-1">
            <div class="d-flex justify-content-between">
              <h1 class="page-subtitle">{{ $t('annonce.my.ongoing.validation.annonce') }}</h1>
            </div>
          </div>
          <div class="other-annonces card-container row row-cards-annonces">
            <PlaceholderCardAnnonce :isAnimated=true :isForHome=true :isGradient=false></PlaceholderCardAnnonce>
            <PlaceholderCardAnnonce :isAnimated=true :isForHome=true :isGradient=false></PlaceholderCardAnnonce>
            <PlaceholderCardAnnonce :isAnimated=true :isForHome=true :isGradient=false></PlaceholderCardAnnonce>
            <PlaceholderCardAnnonce :isAnimated=true :isForHome=true :isGradient=false></PlaceholderCardAnnonce>
          </div>
        </div>

        <div key="homePlaceHolder-validated" class="mt-4">
          <div class="mb-1">
            <div class="d-flex justify-content-between">
              <h1 class="page-subtitle">{{ $t('annonce.my.validated.annonce') }}</h1>
            </div>
          </div>
          <div class="other-annonces card-container row row-cards-annonces">
            <PlaceholderCardAnnonce :isAnimated=true :isForHome=true :isGradient=false></PlaceholderCardAnnonce>
            <PlaceholderCardAnnonce :isAnimated=true :isForHome=true :isGradient=false></PlaceholderCardAnnonce>
            <PlaceholderCardAnnonce :isAnimated=true :isForHome=true :isGradient=false></PlaceholderCardAnnonce>
            <PlaceholderCardAnnonce :isAnimated=true :isForHome=true :isGradient=false></PlaceholderCardAnnonce>
          </div>
        </div>
      </transition-group>

      <transition-group v-if="!isLoading" name="listCustomTransition">
        <div v-for="(annonceGroup, index) in annonceData" :key="index+'-annonceGroup'" class="mt-4">
          <div class="mb-1">
            <div class="d-flex justify-content-between">
              <h1 class="page-subtitle">{{
                  annonceGroup.isI18n ? $t(annonceGroup.annonceType) : $t(annonceGroup.title)
                }}</h1>
            </div>
            <div v-if="annonceGroup.savedSearchDescription" class="mt-2 main-grey-medium-color">
              {{ $t('annonce.home.savedSearch.with.filters') }} {{ annonceGroup.savedSearchDescription }}
            </div>
          </div>
          <template v-if="annonceGroup.annonces.length > 0">
            <div v-if="annonceGroup.annonceType === 'VALIDATED'" class="other-annonces cards-container">
              <annonce-card-image-top v-for="annonce in annonceGroup.annonces" :key="annonce.serverId"
                                      :annonce="annonce" class="cursor-pointer" from-my-annonce/>
            </div>
            <div v-else class="last-annonces cards-container">
              <annonce-card-image-left v-for="annonce in annonceGroup.annonces" :key="annonce.serverId"
                                       :annonce="annonce"
                                       class="cursor-pointer" from-my-annonce/>
            </div>
          </template>
          <template v-else>

            <div class="card-container">
              <div class="d-flex">
                <div class="p-3">
                  <img :src="require(`@/assets/images/b122/img-confused.png`)" alt="no result"
                       class="empty-state-img-home">
                </div>
                <div class="empty-state-text">
                  {{ $t(emptyStateText(annonceGroup.annonceType)) }}
                </div>
              </div>
            </div>

          </template>
        </div>
      </transition-group>
    </b-container>
  </div>
</template>


<script>
import api from '../../services/api'
import ShowActions from '../../components/b122/ShowActions.vue'
import BackArrow from '../../components/b122/BackArrow.vue'
import AnnonceCardImageLeft from "../../components/annonce/AnnonceCardImageLeft";
import AnnonceCardImageTop from "../../components/annonce/AnnonceCardImageTop";
import PlaceholderCardAnnonce from "../search/PlaceholderCardAnnonce";

export default {

  name: 'MyAnnonce',
  components: {BackArrow, ShowActions, AnnonceCardImageLeft, PlaceholderCardAnnonce, AnnonceCardImageTop},

  data() {
    return {

      userId: this.$store.getters.userId,
      user: {},
      drafts: [],
      toValidate: [],
      validated: [],
      annonceData: [],
      isLoading: true,
    }
  },

  mounted() {
    this.fetchData()
  },

  methods: {

    async fetchData() {
      await this.fetchMyAnnonce()
    },

    async fetchMyAnnonce() {
      api({
        method: "GET",
        url: '/annonce/getMyAnnonce',
      })
        .then(async (response) => {
          this.drafts = response.data.annoncesDraft
          this.toValidate = response.data.toValidate
          this.validated = response.data.validated
          this.annonceData = response.data
          this.isLoading = false
        })
    },

    emptyStateText(annonceType) {
      if (annonceType === 'DRAFT') {
        return "annonce.mine.emptyText.draft"
      }
      if (annonceType === 'VALIDATED') {
        return "annonce.mine.emptyText.validated"
      }
      if (annonceType === 'TO_VALIDATE') {
        return "annonce.mine.emptyText.to.validate"
      }
      return ""
    },


  }
}
</script>

<style scoped>

.page-subtitle{
  color: var(--main-grey-light);
}

.cards-container {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start; /* Alignement des cartes à gauche */
}

.card-container {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start; /* Alignement des cartes à gauche */
  margin-right: -5px;
  margin-left: -5px;
}


.other-annonces .card-inside-container {
  margin-top: 0.5em;
  flex: 1 1 auto;
  min-width: 250px;
  width: 25%;
  max-width: 25%;
  padding-right: 5px;
  padding-left: 5px;
}

.last-annonces .card-inside-container {
  margin-top: 0.5em;
  flex: 1 0 auto;
  min-width: 300px;
  width: 25%;
  max-width: 25%;
  padding-right: 5px;
  padding-left: 5px;
}

.other-annonces .card {
  display: flex;
  align-items: center;
}


.empty-state-text {
  margin-top: 3.5rem;
  max-width: 300px;
}

.row-cards-annonces {
  margin-right: 0.5em;
  margin-top: 0.5em;
  margin-left: -0.5em;
}

@media (max-width: 768px) {

  .other-annonces .card-inside-container {
    width: 100% !important;
    max-width: 100% !important;
  }

  .last-annonces .card-inside-container {
    width: 100% !important;
    max-width: 100% !important;
  }

}

@media (max-width: 991px) {
  .other-annonces .card-inside-container {
    width: 50%;
    max-width: 50%;
  }

  .last-annonces .card-inside-container {
    width: 50%;
    max-width: 50%;
  }
}


</style>



// WEBPACK FOOTER //
// src/views/user/MyAnnonce.vue